import { defineStore } from 'pinia'
import { useStorage, RemovableRef } from '@vueuse/core'
import { ScopeValue, LanguageValue, SCOPE, LANGUAGE } from './models/localStorage'

// localStorage keys
const SCOPE_KEY =       "selectedScope"
const LANGUAGE_KEY =    "language"

const defaultState = {
    [SCOPE_KEY]:    null as ScopeValue,
    [LANGUAGE_KEY]: null as LanguageValue
}

export const useLocalStorageStore = defineStore('localStorage', {
    state: () => ({
        storage: <RemovableRef<typeof defaultState>>useStorage(
            'candidate',
            defaultState,
            localStorage,
            { mergeDefaults: true }
        )
    }),
    getters: {
        isTechScope (state) {
            return state.storage[SCOPE_KEY] === SCOPE.TECH;
        },
        isFinanceScope (state) {
            return state.storage[SCOPE_KEY] === SCOPE.FINANCE;
        },
        getScope(state) {
            const scope = state.storage[SCOPE_KEY] as ScopeValue;
            if (!scope)
                console.info(SCOPE_KEY, "not set");

            return scope;
        },
        getLanguage(state) {
            const language = state.storage[LANGUAGE_KEY] as LanguageValue;
            if (!language)
                console.info(LANGUAGE_KEY, "not set");

            return language;
        },
        getLanguageKeyByValue() {
            return (value: string) =>
                Object.keys(LANGUAGE).find(key => LANGUAGE[key] === value) as keyof typeof LANGUAGE | undefined;
        },

        /* Temporarily needed - START */
        /* shouldn't be needed in the future, when backend will respond with 'TECH' or 'FINANCE' */
        getScopeRemappedToNumber(state) {
            switch (state.storage[SCOPE_KEY]) {
                case SCOPE.TECH:
                    return 1;
                case SCOPE.FINANCE:
                    return 2;
                default:
                    console.error("Invalid", SCOPE_KEY);
                    return null;
            }
        },
        getScopeKeyFromNumber() {
            return (id: number) => {
                const keys = new Map<number, keyof typeof SCOPE>([
                    [1, "TECH"],
                    [2, "FINANCE"]
                ]);
                if (!keys.has(id)) {
                    console.error("Invalid", SCOPE_KEY);
                    return null;
                }
                return keys.get(id)!;
            }
        },
        getScopeRemappedFromNumber() {            
            return (id: number) => {
                switch (id) {
                    case 1:
                        return SCOPE.TECH;
                    case 2:
                        return SCOPE.FINANCE;
                    default:
                        console.error("Invalid", SCOPE_KEY);
                        return null;
                }
            }
        },
        /* Temporarily needed - END */
    },
    actions: {
        setScope (scope: keyof typeof SCOPE) {
            this.storage[SCOPE_KEY] = SCOPE[scope];
            console.info(SCOPE_KEY, "set to:", SCOPE[scope]);
        },
        setLanguage(language: keyof typeof LANGUAGE) {
            this.storage[LANGUAGE_KEY] = LANGUAGE[language];
            console.info(LANGUAGE_KEY, "set to:", LANGUAGE[language]);
        }
    }
})